export default __webpack_public_path__ + "assets/images/b291e099565bd3d9f9be744439fdde55.svg";